<template>
  <div class="training-card-view">

    <h4 style="margin-bottom: 30px;">经历{{index + 1}}</h4>

    <div class="input-row" :id="'cultivate_' + item.uuid + '_name_view'">
      <div class="column left-label">*培训名称：</div>
      <div class="column">
        <el-input :class="[ (noticed && !item.name) ? 'red-border' : '']" v-model="item.name" placeholder="请输入培训名称"
          clearable />
      </div>
    </div>

    <div class="input-row" :id="'cultivate_' + item.uuid + '_unit_view'">
      <div class="column left-label">*培训单位：</div>
      <div class="column">
        <el-input :class="[ (noticed && !item.unit) ? 'red-border' : '']" v-model="item.unit" placeholder="请输入培训单位"
          clearable />
      </div>
    </div>

    <div class="input-row" :id="'cultivate_' + item.uuid + '_location_view'">
      <div class="column left-label">*培训地点：</div>
      <div class="column">
        <el-input :class="[ (noticed && !item.location) ? 'red-border' : '']" v-model="item.location" placeholder="请输入培训地点"
          clearable />
      </div>
    </div>

    <div class="input-row" :id="'cultivate_' + item.uuid + '_strBeginDate_view'">
      <div class="column left-label">*开始时间：</div>
      <div class="column">
        <el-date-picker clearable :class="[ (noticed && !item.strBeginDate) ? 'red-border' : '']" v-model="item.strBeginDate"
          :picker-options="pickerOptions" align="right" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
          placeholder="请选择日期">
        </el-date-picker>
      </div>
    </div>

    <div class="input-row" :id="'cultivate_' + item.uuid + '_strEndDate_view'">
      <div class="column left-label">*结束时间：</div>
      <div class="column">
        <el-date-picker clearable :class="[ (noticed && !item.strEndDate) ? 'red-border' : '']" v-model="item.strEndDate"
          :picker-options="pickerEndOptions" align="right" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
          placeholder="请选择日期">
        </el-date-picker>
      </div>
    </div>

    <div class="input-row" :id="'cultivate_' + item.uuid + '_photos_view'">
      <div class="column left-label picture-upload-label">*参培证明材料：</div>
      <div class="column">
        <el-upload :class="[ (noticed && item.photos.length == 0) ? 'red-border' : '', 'files-upload']" action="https://api.shslqxh.com/upload/files"
          :headers="headers" name="files" :limit="fileLimit" :file-list="initialFileList" :accept="acceptTypes"
          list-type="picture-card" :on-exceed="handleExceed" :on-remove="handleFileRemove" :before-remove="beforeRemoveFile"
          :on-preview="handlePreview" :on-success="handleUploadSuccess">
          <i class="el-icon-plus"></i>
          <div slot="tip" class="el-upload__tip">请上传与本人各项证书相符的参培证明材料，如：培训通知、培训手册及花名册、成绩单、培训图片等。</div>
        </el-upload>
      </div>
    </div>
    <div v-if="index != 0"><a class="delete-button" href="javascript:void(0)" @click="deleteCardItem">删除</a></div>
    <image-preview-view v-if="dialogVisible" :picture-list="dialogImageModel.list" :initial-index="dialogImageModel.index"
      v-on:close="closeImagePreviewView" />

  </div>
</template>

<script>
  import ImagePreview from "../../../common/ImagePreview.vue";
  import PictureTool from "../../../../js/picture-tool.js";
  export default {
    name: "TrainingCardItemVue",
    props: {
      item: {
        type: Object,
        default: null
      },
      index: {
        type: Number,
        default: 0,
      },
      noticed: {
        type: Boolean,
        default: false,
      }
    },
    components: {
      'image-preview-view': ImagePreview
    },
    data() {
      return {
        headers: {},

        dialogImageModel: null,
        dialogVisible: false,

        fileLimit: 20,
        pickerOptions: {
          disabledDate: (time) => {
            return this.dealWithDisableStartDate(time);
          }
        },

        pickerEndOptions: {
          disabledDate: (time) => {
            return this.dealWithDisableEndDate(time);
          }
        },

        initialFileList: [],
      }
    },
    computed: {
      acceptTypes() {
        return PictureTool.acceptTypes;
      },
    },
    mounted() {
      let token = this.$store.state.dataStore.getToken();
      this.headers.token = token;
      this.initData();
    },
    methods: {
      closeImagePreviewView() {
        this.dialogVisible = false;
        this.dialogImageModel = null;
      },
      initData() {
        let item = this.item;
        if (item == null) {
          return;
        }
        let initialFileList = [];
        if (item != null && item.photos.length > 0) {
          for (let i = 0; i < item.photos.length; i++) {
            initialFileList.push(item.photos[i])
          }
        }
        this.initialFileList = initialFileList;
      },

      dealWithDisableStartDate(time) {
        let isAfterNow = this.dealDisableDate(time);
        if (isAfterNow) {
          return isAfterNow;
        }
        let endDate = this.item.strEndDate;
        if (endDate) {
          let endTime = this.$moment(endDate);
          let startTime = this.$moment(time);
          return endTime - startTime < 0;
        }
        return isAfterNow;
      },
      dealWithDisableEndDate(time) {
        let isAfterNow = this.dealDisableDate(time);
        if (isAfterNow) {
          return isAfterNow;
        }
        let startDate = this.item.strBeginDate;
        if (startDate) {
          let startTime = this.$moment(startDate);
          let endTime = this.$moment(time);
          return endTime - startTime < 0;
        }
        return isAfterNow;
      },

      dealDisableDate(time) {
        return new Date().getTime() - (new Date(time).getTime()) < 0;
      },
      beforeRemoveFile(file, fileList) {
        return this.$confirm(`确定移除当前照片吗？`);
      },
      handleExceed(files, fileList) {
        this.$message.warning(
          `当前限制选择 ${ this.fileLimit } 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      handleFileRemove(file, fileList) {
        let url = file.response;
        if (url == undefined) {
          url = file.url;
        }
        let index = this.item.photos.findIndex(function(item) {
          return item.url == url;
        });
        this.item.photos.splice(index, 1);
        if (this.item.photos.length < this.fileLimit) {
          // $("#idverify_view_outer .files-upload .el-upload--picture-card").show();
        }
        // this.updatepassportPhotos();
      },
      handlePreview(file) {
        let url = file.response;
        if (url == undefined) {
          url = file.url;
        }
        let photos = this.item.photos;
        let index = photos.findIndex(function(item) {
          return item.url == url;
        });
        if (index == -1) {
          index = 0;
        }
        this.dialogImageModel = {
          list: photos,
          index
        };
        this.dialogVisible = true;
      },

      handleUploadSuccess(res, file) {
        if (typeof res == 'string') {
          let name = file.name;
          let url = res;
          let obj = {
            name,
            url
          };
          this.item.photos.push(obj);
          if (this.item.photos.length >= this.fileLimit) {
            // $("#idverify_view_outer .files-upload .el-upload--picture-card").hide();
          }
          // this.updatepassportPhotos();
        }
      },

      deleteCardItem() {
        let _this = this;
        this.$confirm('您正在进行删除操作，删除后信息不会保存，需重新填写', '提示', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          _this.$emit('deleteItem', {
            index: _this.index
          });
        }).catch(() => {
          //...取消
          // console.log('不退出');
        });
      },
    }
  }
</script>

<style scoped>
  @import url("../../../../css/input-row.css");

  .training-card-view {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  .training-card-view {
    margin-top: 50px;
  }

  .training-card-view:first-child {
    margin-top: 20px;
  }

  .training-card-view .delete-button {
    color: #999;
    text-decoration: underline;
  }

  .training-card-view .delete-button:hover {
    color: #23527c;
  }
</style>



// WEBPACK FOOTER //
// src/components/personal/coachApplications/cards/TrainingCardItem.vue